// tslint:disable: naming-convention
import {Action} from '@ngrx/store';
import {
    MutationChangeDoctorArgs,
    MutationCreateDoctorArgs,
    MutationDeleteDoctorArgs,
} from '../../../../mdqx-graphql-types';
import { DoctorEntity } from '../../../../entities/mdqx/doctor/doctor.entity';

export enum DoctorActionTypes {
    PostDoctorRequest = '[Doctor] Post Request',
    PostDoctorResponse = '[Doctor] Post Response',
    GetDoctorsRequest = '[Doctors] Get Request',
    GetDoctorsResponse = '[Doctors] Get Response',
    PatchDoctorRequest = '[Doctor] Patch Request',
    PatchDoctorResponse = '[Doctor] Patch Response',
    DeleteDoctorRequest = '[Doctor] Delete Request',
    DeleteDoctorResponse = '[Doctor] Delete Response'
}

export class PostDoctorRequest implements Action {
    readonly type = DoctorActionTypes.PostDoctorRequest;
    constructor(public Payload: MutationCreateDoctorArgs) {}
}

export class PostDoctorResponse implements Action {
    readonly type = DoctorActionTypes.PostDoctorResponse;
    constructor(public Payload: DoctorEntity) {}
}

export class GetDoctorsRequest implements Action {
    readonly type = DoctorActionTypes.GetDoctorsRequest;
}

export class GetDoctorsResponse implements Action {
    readonly type = DoctorActionTypes.GetDoctorsResponse;
    constructor(public Payload: DoctorEntity[]) {}
}

export class PatchDoctorRequest implements Action {
    readonly type = DoctorActionTypes.PatchDoctorRequest;
    constructor(public Payload: MutationChangeDoctorArgs) {}
}

export class PatchDoctorResponse implements Action {
    readonly type = DoctorActionTypes.PatchDoctorResponse;
    constructor(public Payload: DoctorEntity) {}
}

export class DeleteDoctorRequest implements Action {
    readonly type = DoctorActionTypes.DeleteDoctorRequest;
    constructor(public Payload: MutationDeleteDoctorArgs) {}
}

export class DeleteDoctorResponse implements Action {
    readonly type = DoctorActionTypes.DeleteDoctorResponse;
    constructor(public Payload: number) {}
}

export type DoctorActions =
    | PostDoctorRequest
    | PostDoctorResponse
    | GetDoctorsRequest
    | GetDoctorsResponse
    | PatchDoctorRequest
    | PatchDoctorResponse
    | DeleteDoctorRequest
    | DeleteDoctorResponse;
